// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2rGEh","errors":"Errors_errors__OxOBT"};